import { IDynamicRuleSetOptions } from '../../../Models/GameSetupModels';
import { PlayRules, RulesetCard } from '../Lobby/LobbyRules';
import { rulesetNameFromOptions, rulesSummary } from '../Lobby/rulesets';
import SpecialCards from '../Lobby/SpecialCards';
import { SectionHeading } from '../StartScreen/StartScreen';

export interface IGameRulesProps {
  options: IDynamicRuleSetOptions | undefined;
}

export default function GameRules({ options }: IGameRulesProps) {
  if (!options) {
    return (
      <section
        aria-label="Rules"
        className="flex h-full items-center justify-center bg-page p-[16px] text-[14px] font-medium text-ink-muted"
      >
        Rules aren't available for this game
      </section>
    );
  }

  return (
    <section
      aria-label="Rules"
      className="flex h-full flex-col gap-[16px] overflow-auto bg-page p-[16px] text-ink"
    >
      <RulesetCard
        name={rulesetNameFromOptions(options)}
        summary={rulesSummary(options)}
      />
      <div className="flex flex-col gap-[8px]">
        <SectionHeading id="game-rules-special-cards">
          Special cards
        </SectionHeading>
        <SpecialCards labelledBy="game-rules-special-cards" options={options} />
      </div>
      <div className="flex flex-col gap-[8px]">
        <SectionHeading id="game-rules-play">Play</SectionHeading>
        <PlayRules labelledBy="game-rules-play" options={options} />
      </div>
    </section>
  );
}
